export const sortDates = <T extends string | Date>(a: T, b: T): number => new Date(a).getTime() - new Date(b).getTime();
